/**
 * Date-extensions locale Arabic (Lybia) [ar-ly]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ar-ly', {
    monthNames: ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    monthShortNames: ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    dayNames: ['الأحد','الإثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'],
    dayShortNames: ['أحد','إثنين','ثلاثاء','أربعاء','خميس','جمعة','سبت']
});
